import { ISSUE_ATTRIBUTE_NAMES } from '../../constants/issue-attribute-names';
import CommonText from './components/CommonText';

export const ExternalId = () => (
  <CommonText fieldName={ISSUE_ATTRIBUTE_NAMES.SUB_ID} label="new.reference" />
);
